import React from 'react';
import {Helmet} from 'react-helmet';

const META_PIXEL_ID = '1175826780972141';
const GOOGLE_ADS_ID = 'AW-16857382404';

const SignUpPixels = () => {
    if(process.env.NODE_ENV !== 'production') {
        return null;
    }

    return (
        <Helmet>
            {/* Meta Pixel Code */}
            <script>
                {`
!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${META_PIXEL_ID}');
fbq('track', 'PageView');
                `}
            </script>
            <noscript>
                {`<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1" />`}
            </noscript>
            {/* End Meta Pixel Code */}

            {/* Google tag (gtag.js) */}
            <script async src={`https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`} />
            <script>
                {`
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', '${GOOGLE_ADS_ID}');
                `}
            </script>
        </Helmet>
    );
};

export default SignUpPixels;
